import dayjs from 'dayjs';
import {chunk} from 'lodash-es';
import {AvailabilityApiResponseDay} from '../../../server/routes/availability/types';
import {Day} from '../DayList';

export const getWeekChunks = (days: AvailabilityApiResponseDay[]): Day[][] => {
  const daysWithoutTimes = days.map((day) => omitTimes(day));
  const weeks = chunk(daysWithoutTimes, 7);
  const lastWeek = weeks[weeks.length - 1];

  if (lastWeek.length === 7) {
    return weeks;
  }

  let endDateOfWeek = dayjs(lastWeek[lastWeek.length - 1].date);

  while (lastWeek.length < 7) {
    endDateOfWeek = endDateOfWeek.add(1, 'day');
    const newDay: Day = {
      date: endDateOfWeek.format('YYYY-MM-DD'),
      dayNumber: endDateOfWeek.format('DD'),
      dayName: endDateOfWeek.format('ddd'),
      isAvailable: false,
    };
    lastWeek.push(newDay);
  }

  return weeks;
};

const omitTimes = (payload: AvailabilityApiResponseDay) => {
  // eslint-disable-next-line unused-imports/no-unused-vars, @typescript-eslint/no-unused-vars
  const {times, ...rest} = payload;
  return rest;
};
